function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import classNames from 'classnames';
import CSSMotion from 'rc-motion';
import { render, unmount } from "rc-util/es/React/render";
import raf from "rc-util/es/raf";
import * as React from 'react';
import { getTargetWaveColor } from './util';
import { TARGET_CLS } from './interface';

function validateNum(value) {
  return Number.isNaN(value) ? 0 : value;
}

var WaveEffect = function WaveEffect(props) {
  var className = props.className,
      target = props.target,
      component = props.component;
  var divRef = React.useRef(null);

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      color = _React$useState2[0],
      setWaveColor = _React$useState2[1];

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      borderRadius = _React$useState4[0],
      setBorderRadius = _React$useState4[1];

  var _React$useState5 = React.useState(0),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      left = _React$useState6[0],
      setLeft = _React$useState6[1];

  var _React$useState7 = React.useState(0),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      top = _React$useState8[0],
      setTop = _React$useState8[1];

  var _React$useState9 = React.useState(0),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      width = _React$useState10[0],
      setWidth = _React$useState10[1];

  var _React$useState11 = React.useState(0),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      height = _React$useState12[0],
      setHeight = _React$useState12[1];

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      enabled = _React$useState14[0],
      setEnabled = _React$useState14[1];

  var waveStyle = {
    left: left,
    top: top,
    width: width,
    height: height,
    borderRadius: borderRadius.map(function (radius) {
      return "".concat(radius, "px");
    }).join(' ')
  };

  if (color) {
    waveStyle['--wave-color'] = color;
  }

  function syncPos() {
    var nodeStyle = getComputedStyle(target); // Get wave color from target

    setWaveColor(getTargetWaveColor(target));
    var isStatic = nodeStyle.position === 'static'; // Rect

    var borderLeftWidth = nodeStyle.borderLeftWidth,
        borderTopWidth = nodeStyle.borderTopWidth;
    setLeft(isStatic ? target.offsetLeft : validateNum(-parseFloat(borderLeftWidth)));
    setTop(isStatic ? target.offsetTop : validateNum(-parseFloat(borderTopWidth)));
    setWidth(target.offsetWidth);
    setHeight(target.offsetHeight); // Get border radius

    var borderTopLeftRadius = nodeStyle.borderTopLeftRadius,
        borderTopRightRadius = nodeStyle.borderTopRightRadius,
        borderBottomLeftRadius = nodeStyle.borderBottomLeftRadius,
        borderBottomRightRadius = nodeStyle.borderBottomRightRadius;
    setBorderRadius([borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius].map(function (radius) {
      return validateNum(parseFloat(radius));
    }));
  }

  React.useEffect(function () {
    if (target) {
      // We need delay to check position here
      // since UI may change after click
      var id = raf(function () {
        syncPos();
        setEnabled(true);
      }); // Add resize observer to follow size

      var resizeObserver;

      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(syncPos);
        resizeObserver.observe(target);
      }

      return function () {
        raf.cancel(id);
        resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
      };
    }
  }, []);

  if (!enabled) {
    return null;
  }

  var isSmallComponent = (component === 'Checkbox' || component === 'Radio') && (target === null || target === void 0 ? void 0 : target.classList.contains(TARGET_CLS));
  return /*#__PURE__*/React.createElement(CSSMotion, {
    visible: true,
    motionAppear: true,
    motionName: "wave-motion",
    motionDeadline: 5000,
    onAppearEnd: function onAppearEnd(_, event) {
      var _a;

      if (event.deadline || event.propertyName === 'opacity') {
        var holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        unmount(holder).then(function () {
          holder === null || holder === void 0 ? void 0 : holder.remove();
        });
      }

      return false;
    }
  }, function (_ref) {
    var motionClassName = _ref.className;
    return /*#__PURE__*/React.createElement("div", {
      ref: divRef,
      className: classNames(className, {
        'wave-quick': isSmallComponent
      }, motionClassName),
      style: waveStyle
    });
  });
};

var showWaveEffect = function showWaveEffect(target, info) {
  var _a;

  var component = info.component; // Skip for unchecked checkbox

  if (component === 'Checkbox' && !((_a = target.querySelector('input')) === null || _a === void 0 ? void 0 : _a.checked)) {
    return;
  } // Create holder


  var holder = document.createElement('div');
  holder.style.position = 'absolute';
  holder.style.left = '0px';
  holder.style.top = '0px';
  target === null || target === void 0 ? void 0 : target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
  render( /*#__PURE__*/React.createElement(WaveEffect, Object.assign({}, info, {
    target: target
  })), holder);
};

export default showWaveEffect;